// at the current scale of 0.85 in AP, this will match any preview up to 425px wide or
// 500px in the fan app
export const MOBILE_SELECTOR = 'max-width: 500px';
